import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/files`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  upload({commit}, payload: { formData: FormData }) {
    return axiosInstance.post(baseUrl, payload.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((data) => data.data);
  },
  uploadKeysPicture({commit}, payload: { formData: FormData, keyId: number }) {
    return axiosInstance.post(`${baseUrl}/keys/${payload.keyId}/pictures`,
      payload.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((data) => data.data);
  },
  delete({commit}, payload: { userId: number, fileType: string }) {
    return axiosInstance.delete(baseUrl, {data: payload})
      .then((data) => data.data);
  },
  parseImportFile({commit}, payload: { type: string, formData: FormData, companyId: number }) {
    return axiosInstance.post(`${baseUrl}/import/${payload.type}?companyId=${payload.companyId}`, payload.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((data) => data.data);
  },
  getCraList({commit}, payload: { keyId: number}) {
    return axiosInstance.get(`${baseUrl}/keys/${payload.keyId}/cra`)
      .then((data) => data.data);
  },
  getCra({commit}, payload: { keyId: number, craName: string}) {
    return axiosInstance.get(`${baseUrl}/keys/${payload.keyId}/cra/${payload.craName}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
